import { TextProps, Text, Flex } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { Icons, defaultIconSize } from '@texas/components/shared/Icons';

type GroupType = 'version' | 'option';

interface Props extends TextProps {
  version: number;
  option?: number | null;
  note: string | null;
  type: GroupType;
  linkedVariantId?: number | null;
}

export function CompositionGroupTitle({
  type,
  version,
  option,
  note,
  linkedVariantId,
  ...props
}: Props) {
  const { t } = useTranslation();

  const titleContent = (
    <>
      {type === 'option' ? (
        note ? (
          <Text variant="main" {...props}>
            {t('compositionGroup.option.optionNrNote', { note, nr: version })}
          </Text>
        ) : (
          <Text variant="main" {...props}>
            {t('compositionGroup.option.optionNr', { nr: version })}
          </Text>
        )
      ) : option ? (
        note ? (
          <Text variant="main" {...props}>
            {t('compositionGroup.version.versionNrNote', {
              nr: version,
              note,
              optionNr: option,
            })}
          </Text>
        ) : (
          <Text variant="main" {...props}>
            {t('compositionGroup.version.versionNrOption', {
              nr: version,
              optionNr: option,
            })}
          </Text>
        )
      ) : (
        <Text variant="main" {...props}>
          {t('compositionGroup.version.versionNr', {
            nr: version,
          })}
        </Text>
      )}
    </>
  );

  if (linkedVariantId) {
    return (
      <Flex align="center" gap={2}>
        {titleContent}
        <Icons.Link boxSize={defaultIconSize} />
      </Flex>
    );
  }

  return titleContent;
}
